module.exports = __webpack_public_path__ + "img/lopez.58fbe6e0.png";